// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import axios from 'axios'
import axios from '@/models/API/axios'
import VueAxios from 'vue-axios'
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'bootstrap/dist/css/bootstrap.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueSlider from 'vue-slider-component'//選擇拉條
import 'vue-slider-component/theme/antd.css'
import VueQuillEditor from 'vue-quill-editor'
import directive from "@/models/HELPERS/directive.js";
import JsonExcel from "vue-json-excel";
import Vue2OrgTree from 'vue2-org-tree'
import 'vue2-org-tree/dist/style.css'

import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme


Vue.use(VueAxios, axios)

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.component('loading', VueLoading)
Vue.component('vueSlider', VueSlider)
Vue.use(VueQuillEditor)
Vue.component("downloadExcel", JsonExcel);
Vue.use(Vue2OrgTree)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js